export const useScrollToTop = () => {
	return () => {
		window?.scrollTo(0, 0);
	}
}
